import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { HtmlProps } from './html.props'

export const HtmlType = ComponentTypeFactory.create<HtmlProps>('Html', {
  title: FieldTypeFactory.text({ required: false }),
  content: FieldTypeFactory.html({ required: true }),
  customUrls: FieldTypeFactory.list({
    of: {
      url: FieldTypeFactory.text(),
      text: FieldTypeFactory.text(),
      shouldAuthenticate: FieldTypeFactory.boolean({}),
    },
    required: false,
  }),
})
